import React from 'react';
import { healthcareRoles } from '../mock';
import { Stethoscope, ArrowRight } from 'lucide-react';

export default function Healthcare() {
  return (
    <section id="healthcare" className="jh-section bg-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-16 items-center">
        <div>
          <span className="jh-eyebrow">Healthcare & Aged Care</span>
          <h2 className="jh-h2 text-[#0e1421] mt-4 mb-6">
            Compassionate, Skilled Healthcare Talent from Ghana
          </h2>
          <p className="text-gray-600 leading-relaxed mb-8">
            Ghanaian healthcare professionals are internationally recognised
            for their strong work ethic, excellent English language
            proficiency, compassion, professionalism, respect for the elderly
            and commitment to delivering high-quality care.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-3 mb-8">
            {healthcareRoles.map((r) => (
              <div key={r} className="flex items-center gap-3">
                <span className="w-2 h-2 rounded-full bg-[#E11D2E]" />
                <span className="text-[15px] text-[#0e1421] font-medium">{r}</span>
              </div>
            ))}
          </div>

          <a href="#contact" className="jh-btn-primary">
            Request Healthcare Talent <ArrowRight size={18} />
          </a>
        </div>

        <div className="relative">
          <div className="grid grid-cols-2 gap-4">
            <img
              src="https://images.unsplash.com/photo-1584515933487-779824d29309?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxlbGRlcmx5JTIwY2FyZXxlbnwwfHx8fDE3ODQ4MDA5NDJ8MA&ixlib=rb-4.1.0&q=85"
              alt="Aged care nurse with elderly patient"
              className="rounded-lg w-full h-[180px] sm:h-[220px] md:h-[260px] object-cover mt-10"
            />
            <img
              src="https://images.pexels.com/photos/5722166/pexels-photo-5722166.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
              alt="Ghanaian nurse"
              className="rounded-lg w-full h-[180px] sm:h-[220px] md:h-[260px] object-cover"
            />
            <img
              src="https://images.pexels.com/photos/36706841/pexels-photo-36706841.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
              alt="Caregiver"
              className="rounded-lg w-full h-[180px] sm:h-[220px] md:h-[260px] object-cover"
            />
            <img
              src="https://images.pexels.com/photos/5945799/pexels-photo-5945799.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
              alt="Diverse healthcare team"
              className="rounded-lg w-full h-[180px] sm:h-[220px] md:h-[260px] object-cover mt-10"
            />
          </div>

          {/* Floating stat */}
          <div className="absolute -left-2 md:left-4 -top-4 bg-[#E11D2E] text-white rounded-lg px-5 py-4 shadow-xl flex items-center gap-3">
            <Stethoscope size={26} />
            <div>
              <div className="font-display font-extrabold text-[22px] leading-none">
                10+
              </div>
              <div className="text-[12px] opacity-90">Care Roles Placed</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
